import React from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import DateConverter from "@remotemerge/nepali-date-converter";

export default function Home() {
  const [todayBS, setTodayBS] = React.useState("");

  React.useEffect(() => {
    // Nepali date using Intl API
    const now = new Date();
    const adDate = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;

    // 2. Convert to BS
    // Output format: { year: 2083, month: 1, date: 1, day: 'Monday' }
    const bsDate = new DateConverter(adDate).toBs();

    // 3. Format it for your UI
    // You can use helper arrays for Nepali month names
    const nepaliMonths = [
      "बैशाख",
      "जेठ",
      "असार",
      "साउन",
      "भदौ",
      "असोज",
      "कात्तिक",
      "मंसिर",
      "पुष",
      "माघ",
      "फागुन",
      "चैत",
    ];

    // Helper to convert English digits to Nepali digits
    const toNepaliDigits = (num) =>
      num.toString().replace(/\d/g, (d) => "०१२३४५६७८९"[d]);

    const formattedDate = `${toNepaliDigits(bsDate.year)} ${nepaliMonths[bsDate.month - 1]} ${toNepaliDigits(bsDate.date)}`;

    setTodayBS(formattedDate);
  }, []);
  return (
    <div className="home">
      {/* ── Navbar ── */}
      <nav className="navbar">
        <div className="nav-logo">
          <span className="logo-symbol">✦</span>
          <span className="logo-text">
            <span className="logo-nep">नक्षत्र</span>
            {/* <span className="logo-eng">NAKSHATRA NEPAL</span> */}
          </span>
        </div>
        <ul className="nav-links">
          <li>
            <NavLink to="/" className="nav-link ">
              गृहपृष्ठ
            </NavLink>
          </li>
          <li>
            <NavLink to="/panchange" className="nav-link">
              पञ्चाङ्ग
            </NavLink>
          </li>
          <li>
            <NavLink to="/milan" className="nav-link">
              अष्टकूट वधू–वर मिलान चक्र
            </NavLink>
          </li>
        </ul>
        <div className="nav-cta">
          <span className="cta-btn">{todayBS}</span>
        </div>
      </nav>
    </div>
  );
}
